import { makeVar } from '@apollo/client';

const globalStore = makeVar({
  loading: false,
  error: false,
});

export default globalStore;
